import { createActions } from 'redux-actions';

const constants = {
    GET_SESSIONS_REQUEST: 'GET_SESSIONS_REQUEST',
    GET_SESSIONS_SUCCESS: 'GET_SESSIONS_SUCCESS',
    GET_SESSIONS_FAILURE: 'GET_SESSIONS_FAILURE',

    GET_SESSION_RECORDS_REQUEST: 'GET_SESSION_RECORDS_REQUEST',
    GET_SESSION_RECORDS_SUCCESS: 'GET_SESSION_RECORDS_SUCCESS',
    GET_SESSION_RECORDS_FAILURE: 'GET_SESSION_RECORDS_FAILURE',

    CREATE_SESSION_REQUEST: 'CREATE_SESSION_REQUEST',
    CREATE_SESSION_SUCCESS: 'CREATE_SESSION_SUCCESS',
    CREATE_SESSION_FAILURE: 'CREATE_SESSION_FAILURE',

    UPDATE_SESSION_REQUEST: 'UPDATE_SESSION_REQUEST',
    UPDATE_SESSION_SUCCESS: 'UPDATE_SESSION_SUCCESS',
    UPDATE_SESSION_FAILURE: 'UPDATE_SESSION_FAILURE',

    DELETE_SESSION_REQUEST: 'DELETE_SESSION_REQUEST',
    DELETE_SESSION_SUCCESS: 'DELETE_SESSION_SUCCESS',
    DELETE_SESSION_FAILURE: 'DELETE_SESSION_FAILURE',
};

export { constants };

export const {
    getSessionsRequest,
    getSessionsSuccess,
    getSessionsFailure,
} = createActions(
    constants.GET_SESSIONS_REQUEST,
    constants.GET_SESSIONS_SUCCESS,
    constants.GET_SESSIONS_FAILURE,
);

export const {
    getSessionRecordsRequest,
    getSessionRecordsSuccess,
    getSessionRecordsFailure,
} = createActions(
    constants.GET_SESSION_RECORDS_REQUEST,
    constants.GET_SESSION_RECORDS_SUCCESS,
    constants.GET_SESSION_RECORDS_FAILURE,
);

export const {
    createSessionRequest,
    createSessionSuccess,
    createSessionFailure,
} = createActions(
    constants.CREATE_SESSION_REQUEST,
    constants.CREATE_SESSION_SUCCESS,
    constants.CREATE_SESSION_FAILURE,
);

export const {
    updateSessionRequest,
    updateSessionSuccess,
    updateSessionFailure,
} = createActions(
    constants.UPDATE_SESSION_REQUEST,
    constants.UPDATE_SESSION_SUCCESS,
    constants.UPDATE_SESSION_FAILURE,
);

export const {
    deleteSessionRequest,
    deleteSessionSuccess,
    deleteSessionFailure,
} = createActions(
    constants.DELETE_SESSION_REQUEST,
    constants.DELETE_SESSION_SUCCESS,
    constants.DELETE_SESSION_FAILURE,
);
